import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

const exportConfig = {
  state: {
    hisHeader: {}
  },
  mutations: {
    // update hisHeader
    setHeader (state, param) {
      let { name, value } = param
      state.hisHeader[name] = value
    },
    // init hisHeader
    initHisHeader (state) {
      state.hisHeader = JSON.parse(localStorage.getItem('HISHEADER')) || {}
      console.log(state.hisHeader)
    },
    // set localStorage
    setHeaderToLS (state) {
      localStorage.setItem('HISHEADER', JSON.stringify(state.hisHeader))
    }
  }
}

export default exportConfig
